export const NEW = 0
export const TEXT_EXTRACT = 1
export const RES_EXTRACT = 2
export const INDEXING = 3
export const READY = 4
export const ERROR = 5